// extracted by mini-css-extract-plugin
export default {"logoutBtn":"LogOut_logoutBtn__6A7nB","logOut":"LogOut_logOut__RkU5s","text":"LogOut_text__SDWTx","logOutSvg":"LogOut_logOutSvg__zIj2P"};